import classNames from "classnames";
import { BookingsTable } from "PFApp/components/bookings_table";
import { CalendarSelectProps } from "PFComponents/calendar";
import { CalendarNavigation } from "PFComponents/calendar/bookings_calendar/calendar_navigation";
import { Booking } from "PFTypes";

import { useProfileBookingsContext } from "../profile_bookings_context";
import css from "./bookings_list.module.scss";

type BookingsListProps = CalendarSelectProps & {
  isLoading: boolean;
  checkCanEditBooking: (booking: Booking) => boolean;
  hideMonthSelector?: boolean;
  onBookingClick: (booking: Booking) => void;
  onBookingEdit: (booking: Booking) => void;
  isExpanded: boolean;
};

export const BookingsList = ({
  isLoading,
  checkCanEditBooking,
  hideMonthSelector,
  onBookingClick: onPeriodClick,
  onBookingEdit,
  isExpanded,
  ...calendarSelectProps
}: BookingsListProps) => {
  const { bookings, calendarSearch, refreshBookings } = useProfileBookingsContext();

  return (
    <div className={css.root}>
      {!hideMonthSelector && (
        <div className={css.stickyMonthSelector}>
          <CalendarNavigation
            showArrows
            minDate={calendarSelectProps.minDate}
            maxDate={calendarSelectProps.maxDate}
            displayMonth={calendarSelectProps.displayMonth}
            setDisplayMonth={calendarSelectProps.setDisplayMonth}
            calendarSearch={calendarSearch}
          />
        </div>
      )}
      <div className={classNames(css.editPanel, { [css.disabled]: isLoading })}>
        <BookingsTable
          bookings={bookings}
          withActions
          checkCanEditBooking={checkCanEditBooking}
          onBookingClick={onPeriodClick}
          onBookingEdit={onBookingEdit}
          onBookingDelete={refreshBookings}
          isDense={!isExpanded}
        />
      </div>
    </div>
  );
};
